import React from "react";
import { TextField, InputAdornment, Typography, Box } from "@mui/material";
import { formatForDisplay } from "../shared/formatter";

/**
 * Premium Phone Input Component
 * 
 * - Visual: Displays a styled +255 prefix.
 * - Input: Restricts user to 9 digits (standard TZ local mobile).
 * - Data: Automatically updates parent state with the full 12-digit format (255xxxxxxxxx).
 */
const PhoneInput = ({
    value,
    onChange,
    error,
    helperText,
    label = "Phone Number",
    placeholder = "712 345 678",
    ...props
}) => {
    const handleChange = (e) => {
        // 1. Strip non-digits
        const raw = e.target.value.replace(/\D/g, "");

        // 2. Allow leading 0 and normalize to 9-digit local part
        const normalized = raw.startsWith("0") ? raw.slice(1) : raw;
        if (normalized.length > 9) return;

        // 3. Convert to Backend Format (255...) immediately
        // If the user clears the input, send empty string.
        // Otherwise, always prefix with 255.
        const backendValue = normalized ? `+255${normalized}` : "";

        // 4. Send to parent
        onChange(backendValue);
    };

    return (
        <TextField
            {...props}
            label={label}
            value={formatForDisplay(value)} // Strip 255 for display
            onChange={handleChange}
            placeholder={placeholder}
            error={error}
            helperText={helperText}
            InputProps={{
                startAdornment: (
                    <InputAdornment position="start">
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                bgcolor: 'action.hover',
                                px: 1.5,
                                py: 0.5,
                                borderRadius: '6px',
                                border: '1px solid',
                                borderColor: 'divider',
                                mr: 0.5
                            }}
                        >
                            <Typography variant="body2" sx={{ fontWeight: 800, color: 'text.primary' }}>
                                +255
                            </Typography>
                        </Box>
                    </InputAdornment>
                ),
            }}
        />
    );
};

export default PhoneInput;
